<template>
  <div>
    <div>
      <h2>Average fails</h2>

      <b-tabs v-model="sequence">
        <b-tab v-for="seqType in sequences"
               :key="seqType.value"
               :active="sequence === seqType.value"
               :title="seqType.title"/>
      </b-tabs>

      <table v-if="isLoadedNormal" class="table table-bordered table-sm text-nowrap">
        <thead class="thead-dark">
        <tr>
          <th>Level number</th>
          <th>Plr.count</th>
          <th>Avg.fails</th>
          <th>Upd.time</th>
        </tr>
        </thead>
        <tr
            v-for="item in averageFails"
            :key="item.number"
        >
          <td>{{ item.number }}</td>
          <td>{{ item.plr_count }}</td>
          <td>{{ item.avg_fails }}</td>
          <td>{{ item.utime | getMomentMinStr }}</td>
        </tr>
      </table>

      <loading-indicator v-if="isLoading"/>
    </div>
  </div>
</template>

<script>
import {getMomentMinStr} from '../../util.js';

import LoadingIndicator from '../LoadingIndicator.vue';
import notifier from "../../notifier.js";
import {HTTP} from "../../http-common.js";

const LOAD_STATE_INIT = 1;
const LOAD_STATE_LOADING = 2;
const LOAD_STATE_LOADED_NORMAL = 3;
const LOAD_STATE_LOADED_ERROR = 4;

const MAIN_SEQUENCE = 0;
const HIGH_SOCIETY = 1;

const sequences = [
  {
    value: MAIN_SEQUENCE,
    title: 'Main sequence'
  },
  {
    value: HIGH_SOCIETY,
    title: 'High society'
  },
];

export default {
  name: 'AverageFails',

  components: {
    LoadingIndicator,
  },

  data() {
    return {
      sequences: sequences,

      sequence: MAIN_SEQUENCE,

      loadState: LOAD_STATE_INIT,
      averageFails: null,
    }
  },

  computed: {
    isLoading() {
      return this.loadState === LOAD_STATE_LOADING;
    },

    isLoadedNormal() {
      return this.loadState === LOAD_STATE_LOADED_NORMAL;
    },
  },

  created() {
    this.loadSequenceAverageFails();
  },

  watch: {
    sequence() {
      this.loadSequenceAverageFails();
    }
  },

  methods: {
    loadSequenceAverageFails() {
      notifier.deleteSenderNotifications(this);

      this.loadState = LOAD_STATE_LOADING;

      const requestConf = {
        params: {sequence: this.sequence}
      };

      HTTP.get('/river_rumble/average_fails', requestConf)
          .then(response => {
            const data = response.data.data;
            if (data === null) {
              notifier.showError('Invalid server response. data === null.', {sender: this});
              return;
            }

            this.averageFails = data.average_fails || [];

            this.loadState = LOAD_STATE_LOADED_NORMAL;
          })
          .catch(err => {
            this.loadState = LOAD_STATE_LOADED_ERROR;
            notifier.showError(err, {sender: this});
          });
    },
  },
  filters: {
    getMomentMinStr,
  }
}
</script>
